export default __webpack_public_path__ + "static/media/photo--sm--144.d9b58d3d.jpg";